import theme from "../../../theme";
import {SxStyles} from "../../../types";


export const combineToggleStyles: SxStyles= {
  combineToggle: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: 'center',
    width: '100%',
    '& .MuiTypography-root': {
      mr: '33%',
      textShadow: '6px 20px 36px rgba(0, 0, 0, 0.25)',
      fontFamily: theme.typography.mainFontFamily,
      fontSize: '14px',
      fontWeight: '400',
    },
    '& .mask-box': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'nowrap',
      gap: `calc(${theme.palette.propVars?.index} * 0.3)`,
      width: '100%',
      position: 'relative',
      borderRadius: '22px',
      py: 0.75,
      px: '7px',
      background: theme.palette.neutral?.grey8,
      // ...theme.palette.propVars?.btnBoxShadow,
      '& .mask': {
        position: 'absolute',
        height: `calc(${theme.palette.propVars?.index} * 1.18)`,
        borderRadius: theme.palette.propVars?.borderRadius,
        background: theme.palette.myPrimary?.white,
        boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.15)',
        transition: 'all 0.5s ease',
        transform: 'translateX(0)',
        left: '7px',
        '&.right': {
          left: 'calc(50% + 3.5px)',
          minWidth: "unset",
        },
      },
      '& .MuiButton-root': {
        borderRadius: theme.palette.propVars?.borderRadius,
        color: theme.palette.neutral?.grey50,
        width: `100%`,
        fontSize: theme.typography.fs19,
        height: `calc(${theme.palette.propVars?.index} * 1.18)`,
        padding: `calc(${theme.palette.propVars?.index} * 0.45)`,
        textTransform: 'none',
        fontWeight: '400',
        transition: 'all .3s ease-in-out',

        '&.active': {
          '&:hover': {
            backgroundColor: 'unset',
          },
        },
        '&:hover:not(.active) ': {
          color: theme.palette.neutral?.grey80,
          backgroundColor: 'unset',
          '& svg': {
            '&.union': {
              fill: theme.palette.neutral?.grey80
            },
            '& .border': {
              stroke: theme.palette.neutral?.grey80
            },
            '& .play': {
              fill: theme.palette.neutral?.grey80
            }
          },
        },
      },
    },
  },
};
